/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationMessage } from '../../models/notification-message';
import { UserGuidDto } from '../../models/user-guid-dto';

export interface ApiEmployeeGiveRecordDeletionPermissionPost$Params {
  'api-version'?: string;
      body?: UserGuidDto
}

export function apiEmployeeGiveRecordDeletionPermissionPost(http: HttpClient, rootUrl: string, params?: ApiEmployeeGiveRecordDeletionPermissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiEmployeeGiveRecordDeletionPermissionPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiEmployeeGiveRecordDeletionPermissionPost.PATH = '/api/employee/give-record-deletion-permission';
